import { Avatar, AvatarProps } from "antd";
import { FC } from "react";

export type IncAvatarProps = AvatarProps;

export const IncAvatar: FC<IncAvatarProps> = (props) => <Avatar {...props} />;
